export const convertToBase64 = async (file: File) =>
  new Promise<string>(resolve => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(file as Blob);
  });
